if (!customElements.get('cart-reservation-timer')) {
  class CartReservationTimer extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-cart-reservation-value]');
      if (!this.output) return;

      const durationMinutes = Number.parseInt(this.dataset.durationMinutes, 10);
      if (!Number.isFinite(durationMinutes) || durationMinutes <= 0) return;

      this.endTime = this.getEndTime(durationMinutes);
      this.renderTime();
      this.intervalId = window.setInterval(() => this.renderTime(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) window.clearInterval(this.intervalId);
    }

    getEndTime(durationMinutes) {
      const newEndTime = Date.now() + durationMinutes * 60 * 1000;

      try {
        const storedEndTime = Number.parseInt(window.sessionStorage.getItem(this.dataset.storageKey), 10);
        if (Number.isFinite(storedEndTime) && storedEndTime > Date.now()) return storedEndTime;

        window.sessionStorage.setItem(this.dataset.storageKey, String(newEndTime));
      } catch (_error) {
        // Storage can be unavailable in privacy-restricted browser contexts.
      }

      return newEndTime;
    }

    renderTime() {
      const remainingMilliseconds = Math.max(0, this.endTime - Date.now());
      const remainingSeconds = Math.ceil(remainingMilliseconds / 1000);
      const minutes = Math.floor(remainingSeconds / 60).toString().padStart(2, '0');
      const seconds = (remainingSeconds % 60).toString().padStart(2, '0');

      this.output.textContent = `${minutes}:${seconds}`;

      if (remainingMilliseconds === 0 && this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = undefined;
      }
    }
  }

  customElements.define('cart-reservation-timer', CartReservationTimer);
}
